import React, { useState, useEffect } from 'react';
import QuestionBooksView from './QuestionBooksView';
import QuestionBooksMetricsView from './QuestionBooksMetricsView';
import { useSession } from 'src/app/hooks/useSession';
import Onboarding from 'src/app/components/Onboarding';
import { useTranslation } from 'react-i18next';

function UserQuestionBooks(props) {
  const { t } = useTranslation();
  const { selectedTab, path } = props;
  const { session } = useSession();
  const profiles = session?.user?.profileNames || (session?.user && session?.user['profile-names']) || [];
  const [showOnboarding, setShowOnboarding] = useState(false);

  return (
    <>
      <div className="main-content main-content--block">
        <div className="tab__content">
          {selectedTab === 'apostilas' && <QuestionBooksView selectedTab={selectedTab} />}
          {selectedTab === 'resultados-das-apostilas' && <QuestionBooksMetricsView selectedTab={selectedTab} />}
        </div>
      </div>

      <Onboarding
        show={showOnboarding}
        setShowOnboarding={setShowOnboarding}
        onClose={() => setShowOnboarding(false)}
        path={path}
        profiles={profiles}
        title={t('onboarding.titleQuestionBooks')}
        videoId="0SrjT4xP2-g"
      />
    </>
  );
}

export default UserQuestionBooks;
